<template>
  <div>
    <b-row>
      <b-col sm="3">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Número AIT&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="AIT - Auto de Infração de Trânsito"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{ temValor(auto_infracao_transito.num_ait_composto) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Data Infração"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(auto_infracao_transito.data_infracao)) }}
            {{ temValor(auto_infracao_transito.hora_infracao) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Pontuação da Multa"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{
              temValor(
                auto_infracao_transito.vigencia_codigo_infracao.pontuacao
              )
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Valor da Infração"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{
              temValor(formataReal(valorDaInfracao))
            }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col sm="3">
        <b-form-group
          label="Suspensa?"
          label-size="sm"
          label-class="text-secondary"
        >
          <span
            :class="
              `font-weight-bold text-` +
              getVariantStatus(!auto_infracao_transito.ind_multa_suspensa)
            "
          >
            {{
              temValor(
                obterStatusSimNao(auto_infracao_transito.ind_multa_suspensa)
              )
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Quitada?"
          label-size="sm"
          label-class="text-secondary"
        >
          <span
            :class="
              `font-weight-bold text-` +
              getVariantStatus(auto_infracao_transito.ind_multa_quitada)
            "
          >
            {{
              temValor(
                obterStatusSimNao(auto_infracao_transito.ind_multa_quitada)
              )
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Inscrita Dívida Ativa?"
          label-size="sm"
          label-class="text-secondary"
        >
          <span
            :class="
              `font-weight-bold text-` +
              getVariantStatus(!auto_infracao_transito.ind_multa_divida_ativa)
            "
          >
            {{
              temValor(
                obterStatusSimNao(auto_infracao_transito.ind_multa_divida_ativa)
              )
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Convertida em Advertência?"
          label-size="sm"
          label-class="text-secondary"
        >
          <span
            class="font-weight-bold text-danger"
            v-if="
              auto_infracao_transito.status_auto_infracao_transito
                .codigo_status == 18
            "
            >Sim</span
          >
          <span class="font-weight-bold" v-else>Não</span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">
        <b-form-group
          label="Prescrita?"
          label-size="sm"
          label-class="text-secondary"
        >
          <span
            :class="
              `font-weight-bold text-` +
              getVariantStatus(!auto_infracao_transito.ind_multa_prescrita)
            "
          >
            {{
              temValor(
                obterStatusSimNao(auto_infracao_transito.ind_multa_prescrita)
              )
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Cancelada?"
          label-size="sm"
          label-class="text-secondary"
        >
          <span
            class="font-weight-bold text-danger"
            v-if="auto_infracao_transito.isCancelado()"
            >Sim</span
          >
          <span class="font-weight-bold" v-else>Não</span>
        </b-form-group>
      </b-col>


      <b-col sm="3" v-if="auto_infracao_transito.status_auto_infracao_transito.codigo_status == 9">
        <b-form-group
          label="Data Cancelamento"
          label-size="sm"
          label-class="text-secondary"
        >
          
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(auto_infracao_transito.data_cancelamento)) }}
          </span>
        </b-form-group>
      </b-col>

    </b-row>
    <b-row v-if="auto_infracao_transito.status_auto_infracao_transito.codigo_status == 9">
      <b-col sm="3"></b-col>
      

      <b-col sm="9">
        <b-form-group
          label="Motivo Cancelamento"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(auto_infracao_transito.motivo_cancelamento.descricao) }}
          </span>
        </b-form-group>
      </b-col>

    </b-row>

    <hr />
    <b-row>
      <b-col sm="3">
        <b-form-group
          label="Placa"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(placa_veiculo) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="RENAVAM"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{
              temValor(
                auto_infracao_transito.veiculo_auto_infracao_transito
                  .codigo_renavam
              )
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Município Placa"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{
              temValor(
                auto_infracao_transito.veiculo_auto_infracao_transito
                  .municipio_emplacamento.nome
              )
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="UF da Placa"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{
              temValor(
                auto_infracao_transito.veiculo_auto_infracao_transito
                  .uf_emplacamento
              )
            }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col sm="3">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Nº Processamento&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="Número de identificação da multa pelo DETRAN"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{ temValor(auto_infracao_transito.numero_processamento_sram) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label-size="sm"
          label-class="text-secondary"
        >
        <template slot="label"
            ><span>Código Renainf&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="Número de controle do auto de infração na Base Nacional"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{ temValor(auto_infracao_transito.codigo_renainf) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label-size="sm"
          label-class="text-secondary"
        >
        <template slot="label"
            ><span>Código Lançamento&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="Número de identificação da multa pela Secretaria Municipal de Fazenda da PBH"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{ temValor(auto_infracao_transito.codigo_lancamento_siatu) }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <b-row v-if="!auto_infracao_transito.isCancelado()">
      <b-col sm="3">
        <b-form-group
          label="Prazo Entrada de Defesa de Autuação"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(auto_infracao_transito.prazo_defesa)) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Prazo Identificação Condutor Infrator - FICI&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="FICI - Identificação do Condutor Infrator"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(auto_infracao_transito.prazo_fici)) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3" v-if="auto_infracao_transito.temPenalidade()">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Prazo Entrada de Recurso JARI&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="JARI - Junta Administrativa de Recursos de Infrações"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{
              temValor(dataBrasil(auto_infracao_transito.prazo_recurso_jari))
            }}
           
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!auto_infracao_transito.isCancelado() && auto_infracao_transito.temPenalidade()">
      <b-col sm="3">
        <b-form-group
          label="Prazo Vencimento - Pagamento Com Desconto"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{
              temValor(dataBrasil(auto_infracao_transito.prazo_recurso_jari))
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Prazo Entrada de Recurso CETRAN&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="CETRAN - Conselho Estadual de Trânsito"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{
              temValor(dataBrasil(auto_infracao_transito.prazo_recurso_cetran))
            }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <hr v-if="!auto_infracao_transito.isCancelado()" />
    <b-row>
      <b-col sm="12">
        <b-form-group
          label="Local Infração"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(localInfracao) }}</span>
          <span
            class="font-weight-bold"
            v-if="auto_infracao_transito.local_infracao_referencia"
          >
            -
            {{
              auto_infracao_transito.local_infracao_referencia
            }}</span
          >
          <span
            class="font-weight-bold"
            v-if="auto_infracao_transito.local_infracao_complemento"
          >
            - {{ auto_infracao_transito.local_infracao_complemento }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="9">
        <b-form-group
          label="Infração"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(infracao) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Infrator Responsável"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(infratorResponsavel()) }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">
        <b-form-group
          label="Velocidade Permitida"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(velocidade_regulamentada) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Velocidade Medida"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(velocidade_aferida) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Velocidade Considerada"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(velocidade_considerada) }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <b-row v-if="isEletronico">
      <b-col sm="3">
        <b-form-group
          label="Empresa Fiscalizadora"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(empresaFiscalizadora) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3" v-if="isEletronico || isAplicativo">
        <b-form-group
          label="Equipamento"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(equipamento) }} / {{ temValor(marcaModelo) }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-group
          label="Observação"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(observacao) }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <div v-if="!this.multaNic">
      <b-row class="mt-3">
        <b-col>
          <font-awesome-icon
            size="lg"
            :icon="['fa', 'circle-info']"
            class="mr-1"
          />
          <u
            ><strong
              >Serviços oferecidos no Portal de Serviços da PBH</strong
            ></u
          >
        </b-col>
      </b-row>
      <b-card class="mb-2 mt-1" no-body>
        <b-row class="p-2">
          <b-col>
            <b-link
              size="sm"
              class="text-primary"
              style="font-weight: bold"
              target="_blank"
              href="https://servicos.pbh.gov.br/servicos/i/5f64b4a374fa015ab41a46bd/5dc8470253fd6b5bbd99185f/servicos+multa-de-transito-solicitacao-de-efeito-suspensivo"
              title="Serviço Solicitação de Efeito Suspensivo  -  Portal de Serviços PBH"
            >
              <font-awesome-icon
                size="lg"
                :icon="['fa', 'arrow-up-right-from-square']"
              />
              Serviço Solicitação de Efeito Suspensivo - Portal de Serviços PBH
            </b-link>
          </b-col>
        </b-row>
        <b-row class="p-2">
          <b-col>
            <p>
              Se é aplicável o efeito suspensivo (suspensão), devido à
              interposição de Recurso Administrativo, porém a sua multa ainda
              consta ativa em um dos níveis abaixo, utilize o serviço para
              solicitar a regularização da suspensão.
            </p>
            <p>Nível de controle da multa de trânsito:</p>
            <ol>
              <li>
                Nível municipal do órgão autuador (vide campo "Suspensa?" neste
                portal. Se sua multa estiver suspensa, ela constará como
                Suspensa = Sim)
              </li>
              <li>
                Nível municipal fazendário ( se sua multa estiver suspensa, o
                respectivo Código do Lançamento não constará na
                <b-link
                  target="_blank"
                  class="text-primary"
                  href="https://servicos.pbh.gov.br/servicos/i/5e6a2e27ea9b0e547c40477a/5dc8470253fd6b5bbd99185f/servicos+certidao-negativa-de-debitos-cnd-emissao-web"
                  >Certidão Negativa de Débitos - CND</b-link
                >)
              </li>
              <li>
                Nível estadual / nacional (confira se sua multa consta suspensa
                no DETRAN-MG, vide
                <b-link
                  target="_blank"
                  class="text-primary"
                  href="https://detran.mg.gov.br/veiculos/situacao-do-veiculo/consultar-situacao-do-veiculo"
                  >Situação do veículo no DETRAN-MG</b-link
                >)
              </li>
            </ol>
          </b-col>
        </b-row>
        <div
          v-if="
            verificarDataProcessamento(
              dadosAit.auto_infracao_transito.data_processamento_sram
            )
          "
        >
          <b-row class="p-2">
            <b-col>
              <b-link
                size="sm"
                class="text-primary"
                style="font-weight: bold"
                target="_blank"
                href="https://servicos.pbh.gov.br/servicos/i/5e7d0855d9521a26a9eb255c/5dc8470253fd6b5bbd99185f/servicos+notificacao-de-transito-disponibilizacao-de-imagens-foto-video"
                title="Serviço Notificação de Trânsito - Disponibilização de Imagens (foto/vídeo) - Portal de Serviços PBH"
              >
                <font-awesome-icon
                  size="lg"
                  :icon="['fa', 'arrow-up-right-from-square']"
                />
                Serviço Notificação de Trânsito - Disponibilização de Imagens
                (foto/vídeo) - Portal de Serviços PBH
              </b-link>
            </b-col>
          </b-row>
          <b-row class="p-2">
            <b-col>
              <p v-if="isEletronico && verificarDadosEletronicos()">
                Para AIT's emitidos antes de 01/09/2022, a imagem da
                fiscalização eletrônica só está disponível sob demanda. Se
                necessário, solicite via o serviço Notificaçao de trânsito -
                Disponibilização de imagens ( foto / vídeo ).
              </p>
              <p v-else-if="isTalaoManual || isAplicativo">
                Para AIT's emitidos antes de 01/09/2022, a cópia do Auto de
                Infração lavrado pelo Agente de Trânsito só está disponível sob
                demanda. Se necessário, solicite via o serviço Notificaçao de
                trânsito - Disponibilização de imagens.
              </p>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { helperDatas, helperNumeros } from "@/helpers";
import AutoInfracaoTransito from "@/models/AutoInfracaoTransito";
import moment from "moment";

export default {
  components: {},

  props: {
    dadosAit: {
      type: Object,
      default: function () {
        return {};
      },
    },
    auto_infracao_transito: {
      type: Object,
      default: function () {
        return new AutoInfracaoTransito();
      },
    },
    multaNic: {
      type: Boolean,
      default: function () {
        return false;
      },
    },    
  },

  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
    };
  },

  /* */
  computed: {
    isTalaoManual() {
      return this.auto_infracao_transito.isTalaoManual();
    },
    isAplicativo() {
      return this.auto_infracao_transito.isAplicativo();
    },
    isEletronico() {
      return this.auto_infracao_transito.isEletronico();
    },
    isMultaNIC() {
      return this.auto_infracao_transito.isMultaNIC()
    },

    valorDaInfracao()
    {
      return this. isMultaNIC ? this.dadosAit.valor_infracao : this.auto_infracao_transito.vigencia_codigo_infracao.valor_infracao
    },

    localInfracao()
    {
      return this. isMultaNIC ? null : this.auto_infracao_transito.local_infracao_principal      
    },

    infracao() 
    {
      return (
        this.auto_infracao_transito.vigencia_codigo_infracao
          .codigo_ctb_infracao_transito.codigo_infracao_ctb +
        this.auto_infracao_transito.vigencia_codigo_infracao.codigo_ctb_infracao_transito.codigo_desdobramento_infracao_ctb.toString() +
        " - " +
        this.auto_infracao_transito.vigencia_codigo_infracao
          .codigo_ctb_infracao_transito.descricao_infracao
      );
    },

    placa_veiculo() {
      return this.auto_infracao_transito.veiculo_auto_infracao_transito.id !=
        null
        ? this.auto_infracao_transito.veiculo_auto_infracao_transito
            .placa_veiculo
        : this.dadosAit.placa_veiculo;
    },

    velocidade_regulamentada() {
      return this.isEletronico
        ? this.dadosAit.vigencia_velocidade_regulamentada
            .velocidade_regulamentada
        : "";
    },

    velocidade_aferida() {
      return this.isEletronico ? this.dadosAit.velocidade_aferida : "";
    },

    velocidade_considerada() {
      return this.isEletronico ? this.dadosAit.velocidade_considerada : "";
    },

    empresaFiscalizadora() {
      return this.isEletronico ? this.dadosAit.empresa_fiscalizacao.nome : "";
    },
    equipamento() {
      return this.isEletronico
        ? this.dadosAit.vigencia_localizacao_equipamento
            .equipamento_fiscalizacao.cod_equipamento
        : "";
    },
    marcaModelo() {
      return this.isEletronico
        ? this.dadosAit.vigencia_localizacao_equipamento
            .equipamento_fiscalizacao.marca_modelo
        : "";
    },

    observacao() {
      return this.isTalaoManual || this.isAplicativo
        ? this.dadosAit.observacao
        : "";
    },
  },

  watch: {},

  methods: {
    verificarDadosEletronicos() {
      var existePropriedade = Object.prototype.hasOwnProperty.call(
        this.dadosAit,
        "documento_ait_eletronico"
      );
      if (existePropriedade) {
        return true;
      } else {
        return false;
      }
    },

    formataReal(vlaor) {
      return helperNumeros.formatReal(vlaor);
    },

    infratorResponsavel() {
      var desc;
      switch (
        this.auto_infracao_transito.vigencia_codigo_infracao
          .codigo_ctb_infracao_transito.infrator_responsavel
      ) {
        case "CON":
          desc = "Condutor";
          break;
        case "PRO":
          desc = "Proprietário";
          break;
        default:
          desc = "OUTROS";
      }
      return desc;
    },

    obterStatusSimNao(status) {
      return status ? "Sim" : "Não";
    },

    dataHoraBrasil(vlaor) {
      return helperDatas.dataHoraBrasil(vlaor);
    },

    dataBrasil(vlaor) {
      return helperDatas.dataBrasil(vlaor);
    },

    temValor(valor) {
      return valor ? valor : "-";
    },

    verificarDataProcessamento(data) {
      return moment(data).isBefore("2022-09-01");
    },

    getVariantStatus(status) {
      return status ? "dark" : "danger";
    },
  },

  mounted() {},
};
</script>

<style scoped>
.imagem_div {
  height: 600px !important;
}

.imagem {
  max-width: 100%;
  width: 600px;
  height: 600px !important;
}

input .form-control-sm {
  font-weight: 700 !important;
}
.input-group-sm > .form-control {
  font-weight: 700 !important;
}
</style>
